<div class="box">
  <div class="box-row header mb-2">
    <app-header-bar [backRoute]="'/jobs'" [autoTranslateTitle]="false" [title]="job?.name || 'job.title'"></app-header-bar>
  </div>
  <app-loading-indicator [loading]="isLoading"></app-loading-indicator>
  @if (job && job.status === JobStatus.OPEN && canWriteJobs) {
    <div class="ml-4 mr-4 mb-2">
      <button class="btn btn-nav float-end" (click)="delete()">
        <span class="material-symbols-outlined me-1">delete</span>
        {{ 'job.delete' | translate }}
      </button>
      <button class="btn btn-nav float-end me-2" (click)="cancel()">
        <span class="material-symbols-outlined me-1">cancel</span>
        {{ 'job.cancel' | translate }}
      </button>
      <div class="clearfix"></div>
    </div>
  }
  @if (job) {
    <div class="card">
      <div class="row">
        <div class="col-sm-4">
          <h6 class="fw-bold">{{ 'job.status' | translate }}</h6>
          <p class="fs-5" [innerHTML]="job.status | toStatusBadge"></p>
        </div>
        <div class="col-sm-4">
          <h6 class="fw-bold">{{ 'job.lastUpdatedAt' | translate }}</h6>
          <p class="fs-5" [innerHTML]="job.lastUpdatedAt | timeAgo"></p>
        </div>
        <div class="col-sm-4">
          <h6 class="fw-bold">{{ 'job.createdAt' | translate }}</h6>
          <p class="fs-5">{{ job.createdAt | dateTime }}</p>
        </div>
        <div class="col-sm-4">
          <h6 class="fw-bold">{{ 'dataconnection.singular' | translate }}</h6>
          <p class="fs-5">{{ job.dataConnection?.name ?? '' }}</p>
        </div>
        @if (job.workflowImport) {
          <div class="col-sm-4">
            <h6 class="fw-bold">{{ 'workflowImport.title' | translate }}</h6>
            @if (workflowImportDownloadUrl) {
              <p class="fs-5"><a [href]="workflowImportDownloadUrl" target="_blank" rel="noopener noreferrer">{{ getWorkflowImportDisplayName() }}</a></p>
            } @else {
              <p class="fs-5">{{ getWorkflowImportDisplayName() }}</p>
            }
          </div>
        }
        @if (job.lastWorker) {
          <div class="col-sm-4">
            <h6 class="fw-bold">{{ 'WORKER' | translate }}</h6>
            <p class="fs-5">{{ job.lastWorker.given_name + ' ' + job.lastWorker.family_name }}</p>
          </div>
        }
        @if (job.device) {
          <div class="col-sm-4">
            <h6 class="fw-bold">{{ 'smart-watch' | translate }}</h6>
            <p class="fs-5">{{ job.device.uniqueIdentifier }}</p>
          </div>
        }
        @if (job.handheld) {
          <div class="col-sm-4">
            <h6 class="fw-bold">{{ 'mdm.singular' | translate }}</h6>
            <p class="fs-5">{{ job.handheld.name }}</p>
          </div>
        }
      </div>
      <div class="table-responsive">
        @if (!job.result.length && job.data.length) {
          <table class="table table-hover mt-4">
            <thead>
              <tr>
                @for (key of getArticleKeys(job.data[0]); track key) {
                  @if (key !== 'job') {
                    <th scope="col">
                      <span class="close">
                        <span (click)="hideColumn(key)" class="material-symbols-outlined">close</span>
                      </span>
                      {{ key | titlecase }}
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @for (result of job.data; track result) {
                <tr>
                  @for (key of getArticleKeys(result); track key) {
                    @if (key !== 'job' && !isHidden(key)) {
                      <td>{{ getResult(result, key) }}</td>
                    }
                  }
                </tr>
              }
            </tbody>
          </table>
        }
        @if (job.result.length > 0) {
          <table class="table table-hover mt-4">
            <thead>
              <tr>
                @for (key of getAllArticleKeysForHeaders(job.result); track key) {
                  @if (key !== 'check' && !isHidden(key)) {
                    <th scope="col">
                      <span class="close">
                        <span (click)="hideColumn(key)" class="material-symbols-outlined">close</span>
                      </span>
                      {{ key | titlecase }}
                    </th>
                  }
                }
                <th scope="col">
                  <span class="close">
                    <span (click)="hideColumn('check')" class="material-symbols-outlined">close</span>
                  </span>
                  {{ 'job.check' | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              @for (result of job.result; track result) {
                <tr [class.done]="result['check']" [class.skipped]="result['skipped']" [class.short]="result['check'] && isShortPick(result)">
                  @for (key of getAllArticleKeysForHeaders(job.result); track key) {
                    @if (key !== 'check' && key !== 'skipped' && !isHidden(key)) {
                      <td>{{ getResult(result, key) }}</td>
                    }
                  }
                  <td>
                    @if (result['check'] && !isHidden('check')) {
                      <span>{{ asString(result['check']) | dateTime }}</span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        <div (click)="resetColumns()" class="btn btn-sm btn-outline-primary">
          <span class="material-symbols-outlined">restart_alt</span>
          <span>{{ 'job.reset-columns' | translate }}</span>
        </div>
      </div>
    </div>
  }
  <app-error [error]="error"></app-error>
</div>
